<template>
  <v-card :elevation="elevation">
    <span v-if="hasNote" class="square"></span>
    <p v-for="(text, index) in formattedBody" :key="index" v-html="text"></p>
  </v-card>
</template>

<script>
export default {
  name: 'MirrorBodyDetailsCard',
  props: {
    body: {
      type: [String, Array],
      required: false,
    },
    elevation: {
      type: String,
      default: '1',
    },
    hasNote: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    formattedBody() {
      if (Array.isArray(this.body)) return this.body;
      return (this.body || '').split('\n');
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/theme.scss';
@import '@/assets/scss/theme-v2.scss';

::v-deep .square::before {
  content: '\25A1';
  margin-right: 7px;
  font-size: 20px;
}

.v-card {
  width: 100%;
  padding: 0 16px;
  margin: 0 0 8px 0px;
}

.v-application p {
  margin-bottom: 0 !important;
}
</style>
